export default __webpack_public_path__ + "static/media/404.e05ca3d7.svg";